import React from "react";
import { cn } from "@/utils";

import { tracking } from "./typography.module.css";

interface HeadingProps extends React.HTMLProps<HTMLHeadingElement> {}
interface ParagraphProps extends React.HTMLProps<HTMLParagraphElement> {}

const Stats: React.FC<ParagraphProps> = ({ className, children, ...props }) => {
  return (
    <p
      className={cn("text-7xl leading-[4.5rem] md:text-9xl md:leading-[8rem]", tracking, className)}
      {...props}
    >
      {children}
    </p>
  );
};

const Display: React.FC<ParagraphProps> = ({ className, children, ...props }) => {
  return (
    <p
      className={cn(
        "text-[2.5rem] leading-[2.8rem] md:text-7xl md:leading-[4.5rem]",
        tracking,
        className
      )}
      {...props}
    >
      {children}
    </p>
  );
};

const H1: React.FC<HeadingProps> = ({ className, children, ...props }) => {
  return (
    <h1 className={cn("text-4xl md:text-5xl md:leading-[3rem]", tracking, className)} {...props}>
      {children}
    </h1>
  );
};

const H2: React.FC<HeadingProps> = ({ className, children, ...props }) => {
  return (
    <h2 className={cn("text-3xl md:text-4xl", tracking, className)} {...props}>
      {children}
    </h2>
  );
};

const H3: React.FC<HeadingProps> = ({ className, children, ...props }) => {
  return (
    <h3 className={cn("text-2xl md:text-3xl", tracking, className)} {...props}>
      {children}
    </h3>
  );
};

const H4: React.FC<HeadingProps> = ({ className, children, ...props }) => {
  return (
    <h4 className={cn("text-xl md:text-2xl", tracking, className)} {...props}>
      {children}
    </h4>
  );
};

const H5: React.FC<HeadingProps> = ({ className, children, ...props }) => {
  return (
    <h5 className={cn("text-lg md:text-xl", tracking, className)} {...props}>
      {children}
    </h5>
  );
};

const H6: React.FC<HeadingProps> = ({ className, children, ...props }) => {
  return (
    <h6 className={cn("text-base md:text-lg", tracking, className)} {...props}>
      {children}
    </h6>
  );
};

const PL: React.FC<ParagraphProps> = ({ className, children, ...props }) => {
  return (
    <p className={cn("text-lg", tracking, className)} {...props}>
      {children}
    </p>
  );
};

const P: React.FC<ParagraphProps> = ({ className, children, ...props }) => {
  return (
    <p className={cn("text-base", tracking, className)} {...props}>
      {children}
    </p>
  );
};

const PS: React.FC<ParagraphProps> = ({ className, children, ...props }) => {
  return (
    <p className={cn("text-sm", tracking, className)} {...props}>
      {children}
    </p>
  );
};

export { Stats, Display, H1, H2, H3, H4, H5, H6, PL, P, PS };
